import {useEvent} from '../../../service/events/events-hook';
import {PublicationPreview} from '../../publication-preview/publication-preview';
import {YandexStoriesCarousel} from '../../stories/yandex-stories-preview/carousel/yandex-stories-carousel';

import {EventInfo} from './event-info';

type PropsType = {
    activeEventId: number | null;
    onClose: VoidFunction;
};

export function EventPreview({activeEventId, onClose}: PropsType): JSX.Element | null {
    const {data: event, isFetching} = useEvent(activeEventId, true);

    if (!activeEventId) {
        return null;
    }

    const isLoading = isFetching || !event;

    return (
        <PublicationPreview
            info={event && <EventInfo event={event} onClose={onClose} />}
            isLoading={isLoading}
            media={
                event &&
                event.images.length > 0 && (
                    <YandexStoriesCarousel
                        slides={event.images.map((image) => ({image: {url: image.url}}))}
                        storyName={event.title}
                    />
                )
            }
            onClose={onClose}
        />
    );
}
